import { ABANDONED_SCREEN, PROGRESS } from 'config/config';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { IRecoverPayment } from 'types/Payment';

import withProgressBar from 'hoc/withProgressBar';
import { getRecoverPayment } from 'services/Api';
import Spinner from '../spinner/Spinner';
import { StatusScreenButton } from '../statusScreen/StatusScreen.styles';

import {
  AbandonedScreenBackToShopButton,
  AbandonedScreenButtonWrapper,
  AbandonedScreenContainer,
  AbandonedScreenIcon,
  AbandonedScreenMessage,
  AbandonedScreenStatus,
  AbandonedScreenStatusText,
  AbandonedScreenWrapper,
} from './AbandonedScreen.styles';

interface IProps {
  paymentId: string;
  redirectToShop?: string;
}

const {
  status,
  statusText,
  icon,
  description,
  backToShopButtonText,
  goToRecoveredPaymentButtonText,
} = ABANDONED_SCREEN;

class AbandonedScreen extends PureComponent<
  IProps & Partial<IContext> & Partial<ITextContext>,
  { isLoading: boolean }
> {
  innerRef = React.createRef<HTMLDivElement>();

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  componentDidMount() {
    const { setPaymentStatusText } = this.props;
    if (setPaymentStatusText) {
      setPaymentStatusText();
    }
  }

  redirectToRecoveredPayments = async () => {
    const { paymentId } = this.props;
    try {
      if (paymentId !== undefined) {
        this.setState({ isLoading: true });
        const recoverPayment: IRecoverPayment = await getRecoverPayment(paymentId);
        window.location.assign(recoverPayment.redirectUrl);
      }
    } catch (e) {
      this.setState(() => {
        throw e;
      });
    }
  };

  goBackToShop = () => {
    const { redirectToShop } = this.props;
    if (redirectToShop) {
      window.location.assign(redirectToShop);
    }
  };

  render() {
    const { redirectToShop } = this.props;
    const { isLoading } = this.state;
    const containerHeight = this.innerRef.current ? this.innerRef.current.offsetHeight : 0;

    return (
      <AbandonedScreenContainer
        isLoading={isLoading}
        height={containerHeight}
        ref={this.innerRef}
        className="abandoned-screen__container"
      >
        {isLoading ? (
          <Spinner isLoading={isLoading} />
        ) : (
          <AbandonedScreenWrapper>
            <AbandonedScreenStatus className="abandoned-screen__status">
              <FormattedMessage id={status} />
            </AbandonedScreenStatus>
            <AbandonedScreenStatusText className="abandoned-screen__statusText">
              <FormattedMessage id={statusText} />
            </AbandonedScreenStatusText>
            <AbandonedScreenIcon className="abandoned-screen__icon">
              <img src={icon} alt="icon" />
            </AbandonedScreenIcon>
            <AbandonedScreenMessage className="abandoned-screen__message">
              <FormattedMessage id={description} />
            </AbandonedScreenMessage>
            <AbandonedScreenButtonWrapper>
              <StatusScreenButton className="abandoned-screen__button">
                <button
                  type="button"
                  className="abandoned-screen__go-to-recovered-payment-button"
                  onClick={this.redirectToRecoveredPayments}
                >
                  <FormattedMessage id={goToRecoveredPaymentButtonText} />
                </button>
              </StatusScreenButton>

              {redirectToShop && (
                <AbandonedScreenBackToShopButton
                  onClick={this.goBackToShop}
                  className="abandoned-screen__back-to-shop-button"
                >
                  <FormattedMessage id={backToShopButtonText} />
                </AbandonedScreenBackToShopButton>
              )}
            </AbandonedScreenButtonWrapper>
          </AbandonedScreenWrapper>
        )}
      </AbandonedScreenContainer>
    );
  }
}

export default withProgressBar(PROGRESS.PAYMENT_FAILURE)(AbandonedScreen);
